document.addEventListener("DOMContentLoaded", e => {

    let sections = document.querySelectorAll('.scroll-section'),
    sectionCount = sections.length,
    activeHeight = window.innerHeight / 2,
    btns = [];

    calculateActiveHeight()

    window.onresize = () => {
        calculateActiveHeight()
        sectionControl()
    }
    
    generateScrollerNav()
    
    sectionControl()

    window.onscroll = () => {
        sectionControl()
    }

    function calculateActiveHeight() {
        activeHeight = window.innerHeight / 2
    }

    function sectionPos(index) {
        return sections[index].getBoundingClientRect().top + window.pageYOffset
    }

    function sectionControl() {
        for (let i = 0; i < sectionCount; i++) {
            if (window.pageYOffset >= sectionPos(i) - activeHeight) {
                for (let index = 0; index < btns.length; index++) {
                    const element = btns[index];
                    element.classList.remove('active')  
                }
                btns[i].classList.add('active')
            }
        }
    }
    
    function generateScrollerNav() {
        for (let i = 0; i < sectionCount; i++) {
            headerNav.insertAdjacentHTML('beforeend', `
                <div class="sidebar__button-wrap">
                    <div class="sidebar__button"></div>
                </div>
            `)
        }
        btns = document.querySelectorAll('.sidebar__button-wrap')
    }

    function scrollToSection(index) {
        window.scrollTo(0, sectionPos(index))
    }

    for (let i = 0; i < btns.length; i++) {
        const element = btns[i];
        element.onclick = () => {
            scrollToSection(i)
        }
    }

    if (document.querySelector('.scroll-section') && sectionCount <= 1) {
        document.querySelector('.scroll-section').classList.add('section_full')
    }
})
